import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer";
import { DataInterop } from "@silvertours/front-shared";
var extractContent = function(answer) {
    var contentfulAnswer = answer;
    return contentfulAnswer.text;
};
export var FaqData = function(param) {
    var faqs = param.faqs, _name = param.name, name = _name === void 0 ? "" : _name;
    return /*#__PURE__*/ _jsx(DataInterop.StructuredData, {
        data: {
            name: name,
            mainEntity: faqs.map(function(param) {
                var answer = param.answer, question = param.question;
                return {
                    "@type": "Question",
                    name: question,
                    acceptedAnswer: [
                        {
                            "@type": "Answer",
                            text: documentToPlainTextString(extractContent(answer))
                        }, 
                    ]
                };
            })
        },
        type: "FAQPage",
        includeContext: true
    });
};
